import { render, staticRenderFns } from "./matching-desc.vue?vue&type=template&id=541024f4"
import script from "./matching-desc.vue?vue&type=script&lang=js"
export * from "./matching-desc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports